import useBasicStores from 'Shared/hooks/useBasicStores'

import { RootStore as SupplierRootStore } from './rootStore/RootStore'

export * from './rootStore/RootStore'
export * from './authStore/AuthStore'
export * from './dashboardStore/DashboardStore'
export * from './metadataStore/MetadataStore'
export * from './helpCenterStore/HelpCenterStore'
export * from './reportStore/ReportStore'
export * from './invoiceStore/InvoiceStore'
export * from './profileStore/ProfileStore'
export * from './registrationDocumentStore/RegistrationDocumentStore'
// INJECT_FROM_PLOP_TABLELIST__STORE
export * from './documentStore/DocumentStore'
export * from './siteVisitStore/SiteVisitStore'

export const useStores = (): SupplierRootStore => useBasicStores<SupplierRootStore>()
